<script>
    import jQuery from "jquery";

    let projectid = jQuery('[project_id]').eq(0).attr('project_id');
    let sharelink = "";

    let i18 = {
        "pl": {
            "Share link": "Udostępnij link",
            "Everyone with this link can access the project:": "Każdy z tym linkiem może uzyskać dostęp do projektu:",
            "Close": "Zamknij",
            "Copy": "Kopiuj"
        }
    }

    function t(message) {
        if (lang === "en") return message;
        if (lang === "pl") return i18['pl'][message] ? i18['pl'][message] : message;
    }

    let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";

    export async function showForm() {
        sharelink = (await Promise.resolve(jQuery.get('/api/getprojectshareurl?project_id='+projectid)))['url'];

        jQuery('#shareByLinkForm').modal();
        jQuery('#shareByLinkForm').on('hidden.bs.modal', () => this.$destroy());
        jQuery('#shareByLinkForm').on('shown.bs.modal',function () {
            document.getElementById('shareByLinkFormInput').focus();
            //select all text
            document.getElementById('shareByLinkFormInput').select();
        });
    }

    function copy() {
        document.getElementById('shareByLinkFormInput').select();
        navigator.clipboard.writeText(document.getElementById('shareByLinkFormInput').value)
    }

</script>

<div id="shareByLinkForm" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">{t("Share link")}</h4>
      </div>
      <div class="modal-body sendByEmailFormEmail">
        <div class="form-group">
            <label for="shareByLinkFormInput">{t("Everyone with this link can access the project:")}</label>
            <div class="form-group-horizontal">
                <input id="shareByLinkFormInput" type="email" bind:value={sharelink}/>
                <button on:click={copy} type="button" class="btn btn-primary">{t("Copy")}</button>
            </div>
        </div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
